import script from "./InputAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAmount.vue?vue&type=script&setup=true&lang=ts"

import "./InputAmount.vue?vue&type=style&index=0&id=12888022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12888022"]])

export default __exports__